import React from 'react';
import { CarliStars } from './CarliStars';
import { briefingSignals } from '../data/demandBriefing';
const toneStyles: Record<string, string> = {
  action: 'border-[#BB5E40]/35 bg-[#BB5E40]/[0.07] text-[#94452E] hover:border-[#BB5E40]',
  neutral: 'border-ink/15 bg-paper text-ink/70 hover:border-ink/35',
  warn: 'border-[#B4801F]/35 bg-[#B4801F]/[0.08] text-[#8A6115] hover:border-[#B4801F]'
};
export function DemandBriefing({
  onSelectSignal
}: {
  onSelectSignal: (id: string) => void;
}) {
  return <section aria-labelledby="briefing-heading" className="rounded-2xl border border-ink/10 bg-paper p-5 shadow-sm sm:p-6" data-id="element-548" data-mp="1xvx3wgfzephn">
      <p id="briefing-heading" className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-[#94452E]" data-id="element-549" data-mp="1jv49rwtldwf2">
        <CarliStars data-id="element-550" data-mp="1owtmdgwgqi59" />
        Carli daily briefing
      </p>

      <p className="mt-3 max-w-4xl font-display text-xl leading-relaxed tracking-tight sm:text-2xl" data-id="element-551" data-mp="8fxquo98sfwq">
        $428K of identified opportunity across 17 brands. Three campaigns are outperforming target, two need attention,
        and 181 units have insufficient demand. Three creatives are waiting for approval.
      </p>

      <div className="mt-5 flex flex-wrap gap-2.5" data-id="element-552" data-mp="11goze9w23ad4">
        {briefingSignals.map(signal => <button key={signal.id} type="button" onClick={() => onSelectSignal(signal.id)} className={`rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${toneStyles[signal.tone]}`} data-id="element-553" data-mp="1gd678r51e6ux">
            {signal.count} {signal.label}
          </button>)}
      </div>
    </section>;
}